import { Component } from 'react';

import { sessionStorage } from '../../../../../../../shared/sessionstorage';

export default class ScrollRecorder extends Component {
  /**
   *
   */
  public componentDidMount() {
    // safari, firefoxでブラウザバックの際にずれる問題の対処
    // 自動でスクロールしないようにmanualに設定(autoの場合、chrome以外でずれるため)
    // ※ 以下の条件を考慮してはじく
    // ・chromeのuaにはChromeに加えてSafariの文字列が入る。
    // ・firefox, safariのuaにはChromeの文字列は入らない。
    // EdgeやOperaは考慮していない。
    const ua = window.navigator.userAgent.toLowerCase();
    if ((ua.indexOf('safari') !== -1 || ua.indexOf('firefox') !== -1) && ua.indexOf('chrome') === -1) {
      // safari, firefoxの場合
      window.history.scrollRestoration = 'manual';
    } else {
      // それ以外
      window.history.scrollRestoration = 'auto';
    }

    // リンクをクリックした場合もしくはリロードした場合は、スクロールポジションを保持しない
    if (window?.performance?.getEntriesByType('navigation')?.[0]?.type !== 'back_forward') {
      sessionStorage.remove(`YAHOO.JP.News.scrollTop.${location.href}`);

      // workaround: リンククリック先のURLにハッシュが付いている場合、Safariでスクロール位置が意図通りにならないので該当要素までスクロールする
      const target = location.hash && document.getElementById(location.hash.replace('#', ''));
      if (target) {
        target.scrollIntoView(true);
      }
    }

    // 保持していたスクロール位置にスクロール
    window.addEventListener('load', this.getScrollPosition, false);

    // safari でブラウザバック時にスクロール位置に戻らないため,キャッシュから読み込んだ際にスクロール位置を復元するようにする
    window.addEventListener('pageshow', this.getScrollPositionFromCache, false);

    // スクロール位置をセッションストレージに保存;
    window.addEventListener('scroll', this.setScrollPosition, false);
  }

  /**
   * アンマウント時にイベントリスナーを取り除く
   */
  public componentWillUnmount() {
    window.removeEventListener('load', this.getScrollPosition, false);
    window.removeEventListener('pageshow', this.getScrollPositionFromCache, false);
    window.removeEventListener('scroll', this.setScrollPosition, false);
  }

  /**
   *
   */
  public render() {
    return null;
  }

  private getScrollPosition = () => {
    const KEY_SESSION = `YAHOO.JP.News.scrollTop.${location.href}`;
    const scrollTop = sessionStorage.get<number>(KEY_SESSION);
    if (scrollTop) {
      window.scrollTo(0, scrollTop);
      sessionStorage.remove(KEY_SESSION);
    }
  };

  private setScrollPosition = () => {
    // ブラウザ、バージョンによってelementが異なるためそれぞれ記載
    sessionStorage.set<number>(
      `YAHOO.JP.News.scrollTop.${location.href}`,
      Math.max(window.pageYOffset ?? 0, document.documentElement.scrollTop ?? 0, document.body.scrollTop ?? 0)
    );
  };

  /**
   * キャッシュが存在する場合にScrollPositionを復元する
   * 主にSafariが対象
   *
   * @param event イベント
   */
  private getScrollPositionFromCache = (event: PageTransitionEvent) => {
    if (event.persisted) {
      this.getScrollPosition();
    }
  };
}
